/**
 * Simple module-level store for attribution data.
 * Captured once during boot, read by useChatState when connecting the socket.
 */

import type { Attribution } from './attribution';

let _attribution: Attribution | null = null;

export function setAttribution(data: Attribution): void {
  _attribution = data;
}

export function getAttribution(): Record<string, unknown> | undefined {
  return _attribution
    ? (_attribution as unknown as Record<string, unknown>)
    : undefined;
}
